import { render, staticRenderFns } from "./TileDataGemeenteprognose.vue?vue&type=template&id=e40a656c"
import script from "./TileDataGemeenteprognose.vue?vue&type=script&lang=js"
export * from "./TileDataGemeenteprognose.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports